import React, { useState } from "react";
import Image from "../../Image/user.jpeg";
import { useDispatch, useSelector } from "react-redux";

import Table from "../Table/Table";

import {
  CalculateExtraWage,
  calculateHourPerDay,
  calculateTimeDifference,
  formatNumberWithCommas,
  formatTime,
  montlyHourWorks,
  SumationExtraHour,

  SumationHourAndLeavingRequest,
  SumationLeavingRequestHour,
  TotalDailyWage,
  TotalSumationWage,
} from "../../Actions/TimeControll";
import Pagination from "../Pagination";
import TabDates from "../Tabs/TabDates";
import { showAttendanceAction } from "../../Actions/UserAction/AttendanceAction";

const YourProfile = ({ userAuth }) => {
  const showAttendance = useSelector((state) => state.showAttendance);
  const { attendances, total } = showAttendance;

  const dispatch = useDispatch();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const handleOnChange = () => {
    dispatch(showAttendanceAction(page, perPage, userAuth?.id, from, to));
  };

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(50);
  const columns = [
    "Full Name",
    "Profile",
    "Actual Check In",
    "Actual Check Out",
    "Check In",
    "Check Out",
    "Approve Time",
    "Extra Hour",
    "Leaving Request",
    "Extra Wage",
    "Daily Wage",
  ];
  // const [userId,setUserId]=useState(null)

  return (
    <>
      <div className="bg-white rounded-md shadow-md m-auto w-[95%] mt-4 pb-5"> 
        <Details attendances={attendances} from={from} to={to} userAuth={userAuth} />

        <TabDates
          from={from}
          to={to}
          setFrom={setFrom}
          setTo={setTo}
          onChange={() => handleOnChange()}
          perPage={perPage}
        />
        <Table columns={columns} attendances={attendances} tfoot={true}>
          {/* <tbody></tbody> */}
          {attendances?.map((atten, index) => {
            return (
              <tr className="p-3 border" key={index}>
                <td className="p-3 border">
                  {" "}
                  {atten?.user?.user_info?.en_name}
                </td>
                <td>
                  <img
                    src={atten?.user?.user_profile_cv?.image || Image}
                    className="object-cover rounded-full size-12 m-auto"
                    alt=""
                  />
                </td>
                <td className="p-3 border text-center font-bold">
                  {" "}
                  <p>{formatTime(atten?.checkin) || 0}</p>
                  <p>{atten?.checkin?.split(" ")[0] || 0}</p>
                </td>
                <td className="p-3  border text-center font-bold">
                  <p>{formatTime(atten?.checkout) || 0}</p>
                  <p>{atten?.checkout?.split(" ")[0] || 0}</p>
                </td>
                <td className="p-3 border font-bold text-center cursor-pointer bg-indigo-600 text-gray-50">
                  {" "}
                  {formatTime(atten?.approve_checkin) || 0}
                  <p>{atten?.approve_checkin?.split(" ")[0] || 0}</p>
                </td>
                <td className="p-3 border text-center font-bold cursor-pointer bg-blue-600 text-gray-50">
                  {" "}
                  {formatTime(atten?.approve_checkout) || 0}
                  <p>{atten?.approve_checkout?.split(" ")[0] || 0}</p>
                </td>
                <td className="p-3 border text-center font-bold">
                  {calculateTimeDifference(
                    atten?.approve_checkin,
                    atten?.approve_checkout
                  ) || 0}
                </td>
                <td
                  className="p-3 border text-center cursor-pointer font-bold bg-indigo-700 text-white"
                  // onContextMenu={(e) => handleRightClick(e, atten.user.id)}
                >
                  <p>
                    {atten?.extra_hour?.split(":")[0] || "00"}h{" "}
                    {atten?.extra_hour?.split(":")[1] || "00"}m
                  </p>
                </td>
                <td
                 
                  className="p-3 border text-center cursor-pointer font-bold bg-opacity-85 bg-indigo-700 text-white"
                >
                  <p>
                    {atten?.leave_request?.split(":")[0] || "00"}h{" "}
                    {atten?.leave_request?.split(":")[1] || "00"}m
                  </p>
                </td>
                <td className="p-3 font-bold border">
                  {" "}
                  {formatNumberWithCommas(atten?.user?.user_info?.extra_wage) ||
                    0}
                </td>{" "}
                <td className="p-3 font-bold border">
                  {" "}
                  {formatNumberWithCommas(
                    atten?.user?.user_info?.hourly_wage
                  ) || 0}
                </td>
              </tr>
            );
          })}
        </Table>

        {total == 0 || attendances?.length == 0 || attendances == undefined ? (
          ""
        ) : (
          <Pagination
            total={total}
            page={page}
            perPage={perPage}
            setPerPage={setPerPage}
          />
        )}
      </div>
      <div className="pb-10"></div>
    </>
  );
};

const Details = ({ attendances, userAuth,from,to }) => {
  let profile = "";

  let users = [];
  attendances?.map((atten) => {
    profile = atten?.user?.user_profile_cv?.image;

    users = atten.user;
  });

  return (
    <div className="flex gap-2 shadow-md rounded-md p-4">
      <div className=" rounded-md w-3/12 bg-yellow-200 overflow-hidden">
        {profile ? (
          <img
            src={profile}
            className=" object-cover w-full size-72 rounded-md shadow-md transition-transform duration-700 transform hover:scale-110 hover:z-10"
            alt=""
          />
        ) : (
          <img
            src={Image}
            className=" object-cover w-full size-72  rounded-md transition-transform duration-700 transform hover:scale-110 hover:z-10"
            alt=""
          />
        )}
      </div>
      <div className="flex flex-col gap-5 w-full">
        <HeadBoxs
          enName={userAuth?.user_info?.en_name}
          krdName={userAuth?.user_info?.krd_name}
        />
        <div className="grid grid-cols-4 h-full gap-5 w-full">
          <Boxs users={users} from={from} to={to} attendances={attendances} />
        </div>
      </div>
    </div>
  );
};

const Boxs = ({ users ,attendances,from,to}) => {
  // console.log()
  const colors = [
    "bg-indigo-600",
    "bg-red-600",
    "bg-blue-600",
    "bg-green-600",
    "bg-pink-600",
    "bg-yellow-600",
    "bg-slate-900",
    "bg-zinc-900",
  ];
  const text = [
    {
      text: "Leaving Request",
      time: SumationLeavingRequestHour(attendances),
      type: "",
    },
    {
      text: "Total Approved Time & Leaving ",
      time: SumationHourAndLeavingRequest(attendances),
      type: "",
    },
    { text: "Total Extra Hour", time: SumationExtraHour(attendances), type: "" },
    {
      text: "Total IQD Per Hour ",
      time: formatNumberWithCommas(TotalDailyWage(users,attendances)),
      type: "IQD",
    },
    {
      text: "Total IQD  Extra Hour",
      time: formatNumberWithCommas(CalculateExtraWage(users,attendances)),
      type: "IQD",
    },
    {
      text: "Total Wage ",
      time: formatNumberWithCommas(TotalSumationWage(users,attendances)),
      type: "IQD",
    },
    {
      text: "Worked in per month ",
      time: calculateHourPerDay(users,from,to),
      type: "",
    },
    {
      text: "Complete Your Time",
      time: montlyHourWorks(users,attendances,from,to),
      type: "",
    },

  
  ];

  return (
    <>
      {Array(8)
        .fill()
        .map((_, index) => {
          return (
            <div
              key={index}
              className={`my-auto text-center h-full text-gray-50 font-bold w-full rounded-md shadow-md p-5 ${colors[index]}`}
            >
              <div className=" ">
                <p className="">{text[index]?.text} :</p>
                <p>
                  {text[index]?.time} {text[index]?.type}
                </p>
              </div>
            </div>
          );
        })}
    </>
  );
};

const HeadBoxs = ({ enName, krdName }) => {
  return (
    <div className="flex justify-between items-center rounded-md shadow-2xl h-full bg-slate-900 text-white px-5  ">
      <p>{enName}</p>
      <p>{krdName}</p>
    </div>
  );
};
export default YourProfile;
